
export default function initSizeSelect(): void {
    const $selectContainer = document.querySelectorAll<HTMLElement>('.js-size-select');

    $selectContainer.forEach($container => {
        new Select($container);
    });
}

class Select {
    $el: HTMLElement | null | undefined;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.init();
    }

    init(): void {
        if (this.$el) {
            const selects = this.$el?.querySelectorAll('.size');

            selects.forEach(select => {
                select.addEventListener('click', () => {
                    selects.forEach(select => select.classList.remove('size--active'))
                    select.classList.add('size--active');
                })
            })
        }
    }
}